import { Polygon, Marker, Popup } from "react-leaflet";
import { divIcon } from "leaflet";
import { Table } from "react-bootstrap";
import SimpleBar from "simplebar-react";

export const SurfaceTriangle = ({ positions }) => {
    return (
        <>
            {
                positions.map(
                    item =>
                        <Marker
                            position={ { lat: item[0], lng: item[1] } }
                            icon={ divIcon({
                                html: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><rect width="10" height="10" fill="#0dcaf0" /></svg>`,
                                className: "marker-icon-point",
                                iconAnchor: [5, 5],
                                iconSize: [16, 16]
                            }) }
                            pointId={ `${ item[0] }-${ item[1] }` }>
                            <Popup className="data-popup data-popup-narrow">
                                <div className='card border-0'>
                                    <div className='card-footer d-flex flex-column justify-content-center mx-2 px-0 text-nowrap'>
                                        <SimpleBar autoHide={ false } className='simplebar-no-autohide' style={ { maxHeight: '15rem' } }>
                                            <Table size="sm" striped>
                                                <tbody>
                                                    <tr className="pr-3">
                                                        <td><strong className="p-0">Height</strong></td>
                                                        <td className="text-end">{item[2]}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </SimpleBar>
                                    </div>
                                </div>
                            </Popup>
                        </Marker>
                )
            }
            <Polygon
                positions={ positions.map(item => [item[0], item[1]]) }
                pathOptions={ { stroke: true, color: "#0dcaf0", weight: 2, fill: true, opacity: 1, fillColor: "#0dcaf0", fillOpacity: 0.3 } }
            />
        </>
    )
}